import log from 'salvo-lite/log'
import Ajaxinate from '../vendor/ajaxinate/ajaxinate'
import 'lazysizes'
import 'lazysizes/plugins/parent-fit/ls.parent-fit'

class InfiniteScroll {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
    }

    onInit () {
        log.debug(this.constructor.name, 'component initialised', this)

        // eslint-disable-next-line no-unused-vars
        const endlessScroll = new Ajaxinate({
            loadingText: 'Loading...',
            container: '#AjaxinateLoop',
            method: 'click'
        })

        document.addEventListener('AjaxinateProductsLoaded', (e) => {
            window.AOS.refreshHard()
        })
    }
}

export default InfiniteScroll



// WEBPACK FOOTER //
// ./src/resources/scripts/components/InfiniteScroll.js